import React, { Component } from "react";
import Link from "../Link/Link";
import {
  Navbar,
  Button,
  Form,
  FormControl,
  Col,
  Container,
  Dropdown,
} from "react-bootstrap";
import AuthorizeService from "../../ApiAuthorization/AuthorizeService";
import UserService from "../../Services/UserService";
import RouterHistory from "../../Router/RouterHistory";
import QueryString from "query-string";
import { ThreeBarsIcon } from "@primer/octicons-react";
import logo from "images/suez_logo.svg";
import photoPlaceholder from "images/user_image_placeholder.svg";
import { appInsights } from "../../../index";
import { Icon } from "@fluentui/react/lib/Icon";
import AppConf from '../../Configuration/AppConfig';

class Header extends Component {
  constructor() {
    super();
    const params = QueryString.parse(location.search);

    this._mounted = false;
    this.state = {
      currentUser: null,
      profils: [],
      photo: null,
      searchedText: params.textSearch ? params.textSearch : "",
      authenticated: false,
      searchFieldErrorMessage: null,
      isValidated: false,
    };
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  componentDidMount() {
    this._mounted = true;
    AuthorizeService.initialize.then(() => {
      if (AuthorizeService.isAuthenticated()) {
        let userInfos = Promise.all([
          UserService.GetGroups(),
          UserService.GetPhoto(),
        ]);
        userInfos.then((data) => {
          if (this._mounted) {
            const validatedId =
              AuthorizeService.getUser().preferred_username.replace(
                /[,;=| ]+/g,
                "_"
              );
            appInsights.setAuthenticatedUserContext(validatedId);
            this.setState({
              authenticated: true,
              currentUser: AuthorizeService.getUser(),
              profils: data[0],
              photo: data[1],
            });
          }
        });
      }
    });
  }

  validateSearch = (value) => {
    if (value.length < 3 && value.length > 0) {
      if (this.state.searchFieldErrorMessage == null) {
        this.setState({
          searchFieldErrorMessage: "Please fill at least 3 characters",
        });
      }
      return false;
    } else if (this.state.searchFieldErrorMessage != null) {
      this.setState({ searchFieldErrorMessage: null });
    }

    return true;
  };

  updateSearchedValue(value) {
    this.setState({
      searchedText: value,
    });
    this.validateSearch(value);
  }

  handleSearch = (event) => {
    if (this.validateSearch(this.state.searchedText)) {
      RouterHistory.push(
        "/project/search?textSearch=" +
          encodeURIComponent(this.state.searchedText)
      );
    }

    if (!this.state.isValidated) {
      this.setState({ isValidated: true });
    }

    event.preventDefault();
    event.stopPropagation();
  };

  showAllProjects = (event) => {
    RouterHistory.push("/project/search?textSearch=");
    this.setState({
      searchedText: "",
    });
    if (!this.state.isValidated) {
      this.setState({ isValidated: true });
    }
    event.preventDefault();
    event.stopPropagation();
  };

  render() {
    const userLabel =
      this.state.currentUser &&
      this.state.currentUser.name +
        (!this.state.profils.length
          ? ""
          : ` (${this.state.profils.join("/")})`);
    const isSearchValid =
      this.state.isValidated && this.state.searchFieldErrorMessage != null;

    return (
      <div className="header fixed-top">
        <Container>
          <Navbar expand="lg">
            <Navbar.Brand>
              <Link to={"/"}>
                <img alt="SUEZ logo" src={logo} />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Form
                className={["searchForm", "mr-auto"]}
                noValidate
                onSubmit={this.handleSearch}
              >
                <Form.Row>
                  <Form.Group>
                    <FormControl
                      className={["searchInput", "mr-sm-2"]}
                      type="text"
                      placeholder="Search a project in CoDAI"
                      isInvalid={isSearchValid}
                      value={this.state.searchedText}
                      onChange={(e) => this.updateSearchedValue(e.target.value)}
                    />
                    {/* <Form.Control.Feedback className='formInputTextHelper' type="invalid">{this.state.searchFieldErrorMessage}</Form.Control.Feedback> */}
                    {isSearchValid && (
                      <div className="formInputTextHelper" type="invalid">
                        {this.state.searchFieldErrorMessage}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} md={false}>
                    <Button
                      className={"searchButton"}
                      type="submit"
                      variant="outline-success"
                      name="search"
                    >
                      <i className="icon-search" />
                      Search
                    </Button>
                    <Button
                      className={"searchButton"}
                      type="button"
                      variant="outline-success"
                      onClick={this.showAllProjects}
                    >
                      <ThreeBarsIcon size={16} />
                      Show all
                    </Button>
                  </Form.Group>
                </Form.Row>
              </Form>

              <div className="d-flex align-items-center">
                {this.state.authenticated && (
                  <>
                    <img
                      alt="user"
                      className="faceCapture rounded-circle"
                      title={userLabel}
                      src={
                        this.state.photo ? this.state.photo : photoPlaceholder
                      }
                    />
                  </>
                )}

                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <span>
                      <Icon iconName="help" />
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      href="https://one4u.sharepoint.com/:b:/r/sites/DataScience/Shared%20Documents/CoDAI/CoDAI_Handbook/CoDAI_Handbook.pdf"
                      rel="noopener noreferrer"
                      target="_blank"
                      title={
                        "Access to CoDAI portal \n and components documentation"
                      }
                    >
                      <span
                        style={{
                          marginRight: "10px",
                          fontSize: 23,
                          fontWeight: "bold",
                        }}
                      >
                        <Icon
                          iconName="DocumentSearch"
                          style={{ fontWeight: "bold" }}
                        />
                      </span>
                      <span class="align-top">Documentation</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="https://teams.microsoft.com/l/channel/19%3aec0cb94a95c848d297855b0fd3c69731%40thread.tacv2/CoDAI?groupId=1b67b14c-f4f8-4645-8d90-17008beffefe&tenantId=f4a12867-922d-4b9d-bb85-9ee7898512a0"
                      rel="noopener noreferrer"
                      target="_blank"
                      title={
                        "Jump to the CoDAI channel \n on the Data Science Teams"
                      }
                    >
                      <span style={{ marginRight: "10px", fontSize: 23 }}>
                        <Icon iconName="TeamsLogo" />
                      </span>
                      <span class="align-top">Data science</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="mailto:so-fran-codai_admin@suez.com?subject=[CoDAI]"
                      title="Contact the support team"
                    >
                      <span style={{ marginRight: "10px", fontSize: 23 }}>
                        <Icon iconName="Mail" />
                      </span>
                      <span class="align-top">Contact us</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      rel="noopener noreferrer"
                      target="_blank"
                      title={
                        "Current CoDAI version"
                      }
                    >
                      <span
                        style={{
                          marginRight: "10px",
                          fontSize: 23,
                          fontWeight: "bold",
                        }}
                      >
                      </span>
                      <span class="align-top">CoDAI version: {AppConf.CodaiVersion.version}</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </div>
    );
  }
}
export default Header;
